import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Path extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "path";
    }
}

export function Path$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Path", void 0, Path, Metadata_StringCategory$reflection());
}

export function Path_$ctor_Z721C83C5(aName) {
    return new Path(aName);
}

export class Publisher extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "publisher";
    }
}

export function Publisher$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Publisher", void 0, Publisher, Metadata_StringCategory$reflection());
}

export function Publisher_$ctor_Z721C83C5(aName) {
    return new Publisher(aName);
}

export class Year extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "year";
    }
}

export function Year$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Year", void 0, Year, Metadata_StringCategory$reflection());
}

export function Year_$ctor_Z721C83C5(aName) {
    return new Year(aName);
}

export class YearAccessed extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "year_accessed";
    }
}

export function YearAccessed$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.YearAccessed", void 0, YearAccessed, Metadata_StringCategory$reflection());
}

export function YearAccessed_$ctor_Z721C83C5(aName) {
    return new YearAccessed(aName);
}

export class Source extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "source";
    }
}

export function Source$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Source", void 0, Source, Metadata_StringCategory$reflection());
}

export function Source_$ctor_Z721C83C5(aName) {
    return new Source(aName);
}

export class Url extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "url";
    }
}

export function Url$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Url", void 0, Url, Metadata_StringCategory$reflection());
}

export function Url_$ctor_Z721C83C5(aName) {
    return new Url(aName);
}

export class Domain extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "domain";
    }
}

export function Domain$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Domain", void 0, Domain, Metadata_StringCategory$reflection());
}

export function Domain_$ctor_Z721C83C5(aName) {
    return new Domain(aName);
}

export class Mimetype extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "mimetype";
    }
}

export function Mimetype$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Mimetype", void 0, Mimetype, Metadata_StringCategory$reflection());
}

export function Mimetype_$ctor_Z721C83C5(aName) {
    return new Mimetype(aName);
}

export class NumWords extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "num_words";
    }
}

export function NumWords$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.NumWords", void 0, NumWords, Metadata_StringCategory$reflection());
}

export function NumWords_$ctor_Z721C83C5(aName) {
    return new NumWords(aName);
}

export class Title extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "title";
    }
}

export function Title$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Title", void 0, Title, Metadata_StringCategory$reflection());
}

export function Title_$ctor_Z721C83C5(aName) {
    return new Title(aName);
}

export class PageId extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "page_id";
    }
}

export function PageId$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.PageId", void 0, PageId, Metadata_StringCategory$reflection());
}

export function PageId_$ctor_Z721C83C5(aName) {
    return new PageId(aName);
}

export class RevisionId extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "revision_id";
    }
}

export function RevisionId$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.RevisionId", void 0, RevisionId, Metadata_StringCategory$reflection());
}

export function RevisionId_$ctor_Z721C83C5(aName) {
    return new RevisionId(aName);
}

export class Wikidata extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "wikidata";
    }
}

export function Wikidata$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Wikidata", void 0, Wikidata, Metadata_StringCategory$reflection());
}

export function Wikidata_$ctor_Z721C83C5(aName) {
    return new Wikidata(aName);
}

export class Categories extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "categories";
    }
}

export function Categories$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.Categories", void 0, Categories, Metadata_StringCategory$reflection());
}

export function Categories_$ctor_Z721C83C5(aName) {
    return new Categories(aName);
}

export class HiddenCategories extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "hidden_categories";
    }
}

export function HiddenCategories$reflection() {
    return class_type("Corpora.Nynorsk.MetadataCategories.HiddenCategories", void 0, HiddenCategories, Metadata_StringCategory$reflection());
}

export function HiddenCategories_$ctor_Z721C83C5(aName) {
    return new HiddenCategories(aName);
}

